// extracted by mini-css-extract-plugin
export const container = "contactForm-module--container--MsgtV";
export const input = "contactForm-module--input--2N93x";